import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import PageSEO from '@/components/feature/PageSEO';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import BrandComparison from './components/BrandComparison';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黄油推荐',
    url: 'https://huangyou-tuijian.com/',
    description: '精选高品质黄油完整指南，汇聚市面主流与小众优质黄油品牌评测与推荐。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://huangyou-tuijian.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黄油推荐 | 精选高品质黄油完整指南',
    description: '汇聚市面主流与小众优质黄油品牌，从风味、产地、用途到性价比全面评测。',
    url: 'https://huangyou-tuijian.com/',
  };

  return (
    <>
      <PageSEO
        title="首页"
        description="黄油推荐为您汇聚市面主流与小众优质黄油品牌，从风味、产地、用途到性价比全面评测，帮助烘焙爱好者、厨师及家庭用户快速找到最适合自己的黄油。"
        keywords="黄油推荐,烘焙黄油推荐,进口黄油推荐,发酵黄油推荐,家用黄油哪个好,黄油品牌对比,黄油选购指南"
        canonicalPath="/"
        schema={{ ...webSiteSchema, ...webPageSchema }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <BrandComparison />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}